<template>
  <div class="wizard">
    <div class="columns is-mobile">
      <div class="column is-12">
        <font-awesome-icon
          v-if="currentPage > 0"
          @click.prevent="previousTab"
          icon="fa-solid fa-circle-chevron-left"
          class="is-clickable"
          size="3x"
        />
      </div>
    </div>
    <div class="columns is-mobile my-2">
      <div class="column is-12">
        <form-wizard ref="formWizard">
          <template>
            <tab name="Parceiros" :selected="true" :formData="formData">
              <div id="form-step-1">
                <partners
                    @nextTab="nextTab"
                    :formData="formData"
                ></partners>
              </div>
            </tab>
            <tab name="Tipo de Integração">
              <div id="form-step-2">
                <integration-types
                    @nextTab="nextTab"
                    :formData="formData"
                    @getPlans="getPlans"
                ></integration-types>
              </div>
            </tab>
            <tab name="Planos">
              <div id="form-step-3">
                <plans
                    @nextTab="nextTab"
                    :formData="formData"
                    ref="plansComponent"
                ></plans>
              </div>
            </tab>
            <tab
                :name="formData.integration.data.type === 'cloud' ? 'Valores Atendimentos' : 'Pacote de Mensagens'"
            >
              <div id="form-step-4">
                <messagePackets
                    @nextTab="nextTab"
                    @previousTab="previousTab"
                    :formData="formData"
                ></messagePackets>
              </div>
            </tab>
            <tab name="Números">
              <div id="form-step-5">
                <extraChips
                    ref="extraChips"
                    @nextTab="nextTab"
                    @previousTab="previousTab"
                    :formData="formData"
                ></extraChips>
              </div>
            </tab>
            <tab name="Acessos">
              <div id="form-step-6">
                <extra-accesses
                    ref="extraAccesses"
                    @nextTab="nextTab"
                    @previousTab="previousTab"
                    :formData="formData"
                ></extra-accesses>
              </div>
            </tab>
            <tab name="Gestão de Pedidos">
              <div id="form-step-7">
                <order-management
                  ref="orderManagement"
                  @nextTab="nextTab"
                  @previousTab="previousTab"
                  :formData="formData"
                ></order-management>
              </div>
            </tab>
            <tab name="Tentativa Recuperação Chip Banido">
              <div id="form-step-8">
                <recover-banned-chip
                  ref="recoverBannedChip"
                  @nextTab="nextTab"
                  @previousTab="previousTab"
                  :formData="formData"
                />
              </div>
            </tab>
            <tab name="Dados Cadastrais">
              <div id="form-step-9">
                <registration-data
                  @nextTab="nextTab"
                  @previousTab="previousTab"
                  :formData="formData"
                ></registration-data>
              </div>
            </tab>
            <tab name="Dados Negócio">
              <div id="form-step-10">
                <company-data
                  @nextTab="nextTab"
                  @previousTab="previousTab"
                  :formData="formData"
                ></company-data>
              </div>
            </tab>
            <tab name="Modo Pagamento">
              <div id="form-step-11">
                <payment-method
                  @nextTab="nextTab"
                  @previousTab="previousTab"
                  :formData="formData"
                ></payment-method>
              </div>
            </tab>
          </template>
        </form-wizard>
      </div>
    </div>
  </div>
</template>

<script>
import FormWizard from './FormWizard.vue';
import Tab from './Tab.vue';

import Partners from "./Tabs/Partners";
import IntegrationTypes from "./Tabs/IntegrationTypes";
import Plans from "./Tabs/Plans";
import MessagePackets from "./Tabs/MessagePackets";
import ExtraChips from "./Tabs/ExtraChips";
import ExtraAccesses from "./Tabs/ExtraAccesses";
import ExtraServices from "./Tabs/ExtraServices";
import RegistrationData from "./Tabs/RegistrationData";
import CompanyData from "./Tabs/CompanyData";
import PaymentMethod from "./Tabs/PaymentMethod";
import OrderManagement from './Tabs/OrderManagement.vue';
import RecoverBannedChip from './Tabs/RecoverBannedChip.vue';

import { useAppStore } from "@/stores/AppStore";

export default {

  name: 'wizard',

  components: {
    FormWizard,
    Tab,
    Partners,
    IntegrationTypes,
    Plans,
    MessagePackets,
    ExtraChips,
    ExtraAccesses,
    ExtraServices,
    RegistrationData,
    CompanyData,
    PaymentMethod,
    OrderManagement,
    RecoverBannedChip
  },

  data() {
    return {
      currentPage: 0
    }
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  mounted () {
    this.$watch(
        () => {
          return this.$refs.formWizard.currentActive
        },
        (val) => {
          this.currentPage = val
        }
    )
  },

  computed: {
    activeFormData() {
      return Object.keys(this.formData)[this.$refs.formWizard.currentActive]
    }
  },

  methods: {
    async getPlans() {
      return await this.$refs.plansComponent.getPlans()
    },
    nextTab(plusPage = 1) {
      if (
        (
          this.formData.integration.data.type === 'cloud' 
          && this.$refs.formWizard.currentActive === 5
          && plusPage === 1
        ) ||
        (
          this.formData.integration.data.type !== 'cloud' 
          && this.$refs.formWizard.currentActive === 6
          && plusPage === 1
        )

      ) { plusPage = 2 }

      const appStore = useAppStore()
      if (this.$refs.formWizard.currentActive >= 6) {
        appStore.showReviewNextButton = true
        return this.$refs.formWizard.nextTab(plusPage)
      }
      appStore.showReviewNextButton = false
      return this.$refs.formWizard.nextTab(plusPage)
    },
    previousTab() {
      let skip = 1;

      const currentPage     = this.$refs.formWizard.currentActive;
      const integrationType = this.formData.integration.data.type;
      if (
          (currentPage === 8 && integrationType !== 'cloud') ||
          (currentPage === 7 && integrationType === 'cloud')
      ) {
        skip = 2;
      }

      this.$flashStorage.destroyAll()
      const appStore = useAppStore()
      if (this.$refs[this.activeFormData] && typeof this.$refs[this.activeFormData].cleanData === 'function') {
        this.$refs[this.activeFormData].cleanData()
      }

      if (this.$refs.formWizard.currentActive >= 6) {
        appStore.showReviewNextButton = true
        return this.$refs.formWizard.previousTab(skip)
      }
      appStore.showReviewNextButton = false
      if (this.$refs.formWizard.currentActive === 1) {
        this.formData.partner.data = {}
      }


      if ((this.formData[this.activeFormData].data).constructor.name === 'Array') {
        this.formData[this.activeFormData].showStep = false
        this.formData[this.activeFormData].data = []
        return this.$refs.formWizard.previousTab(skip)
      }

      if (
          typeof this.formData[this.activeFormData].data === 'object' && this.formData[this.activeFormData].data !== null
      ) {
        this.formData[this.activeFormData].showStep = false
        this.formData[this.activeFormData].data = {}
      }

      return this.$refs.formWizard.previousTab(skip)
    }
  }

}
</script>
